/**
 * Thrown when a component is used without being
 * provided required properties/attributes is added to the application.
 */
export default class MissingComponentAttributeError extends Error {

    /**
     * Creates a new instance of InvalidComponentNameError
     * @param {string} componentName The name of the component that was invalid
     * @param {string} attributeName The name of the attribute that was missing
     */
    constructor(componentName, attributeName) {
        super(`The ${componentName} component requires the ${attributeName} attribute.`);

        this.componentName = componentName;
        this.attributeName = attributeName;
    }
}



// WEBPACK FOOTER //
// ./source/framework/errors/MissingComponentAttributeError.js